module.exports = __webpack_public_path__ + "static/media/ryan.f217f346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ryan.jpg
// module id = 1371
// module chunks = 0